let Image = function ($uibModal, $http, SERVER_URL) {
  "ngInject";

  return {
    openDetail: openDetail,
    deleteImage: deleteImage
  }

  function openDetail(imageSource, imageId, callback) {
    return $uibModal.open({
      component: 'imageDetail',
      // size: 'lg',
      resolve: {
        imageSource: () => imageSource,
        imageId: () => imageId,
        callback: () => callback
      }
    })
  }

  function deleteImage(id) {
    console.log("Delete image from service!", id);
    return $http.delete(SERVER_URL + "/images/" + id);
  }

}
export default Image;



// WEBPACK FOOTER //
// ./client/app/services/imageService/image.service.js